export default __webpack_public_path__ + "static/media/NFLFooterCropped.9f77d18c.png";